export const FilesRoute = 'files';

export const FileFilterFields = {
  ID: 'id',
  NAME: 'name',
  DISPLAY_NAME: 'display_name',
  SELECT_PLACEHOLDER: 'Select',
  CLIENT: 'Client',
  CLIENT_ID: 'client_id',
  ORDER: 'Order',
  ORDER_ID: 'order_id',
  LINE_ITEM: 'Line Item',
  LINE_ITEM_ID: 'line_item_id',
  FILE_TYPE_TITLE: 'File Type',
  FILETYPE: 'filetype',
  UPLOADED_BY_TITLE: 'Uploaded By',
  UPLOADED_BY_USER_ID: 'uploaded_by_user_id',
  UPLOADED_BY: 'uploaded_by',
  UPLOADED_ON_TITLE: 'Uploaded On',
  UPLOADED_ON: 'created_at',
  TAG: 'Tag',
  TAG_ID: 'tag_id',
  FILES: 'files',
};

export const FilesEvents = {
  APPLY_FILTERS: 'apply-filters',
  CLEAR_FILTERS: 'clear-filters',
};

export const OpenStatusType = 'open';
